import { Injectable } from '@angular/core';
import { Item } from '../models/item';
import { CartItem } from './cartItem';
// import { Cart } from './cart';
import { BehaviorSubject, Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, first, map, tap } from 'rxjs/operators';
import { Payment, Transaction } from './payment';
import { Currencies, CurrencyConverterService } from '../services/currency-converter.service';
import { Shop } from './shop';
import { AngularFirestore } from '@angular/fire/firestore';
// import { convertPriceToTL } from './../utilities/cart-utilities';

@Injectable()
export class CartService {
   // private cart = new Cart([]);
   // private cartSubject = new BehaviorSubject<Cart>(this.cart);

   // activeCart$: Observable<Cart> = this.cartSubject.asObservable();

   currencies$: Observable<Currencies>;

   shopInfo: Shop;

   constructor(private currServ: CurrencyConverterService) {
      // console.log('Cart service instantiated');

      this.currencies$ = this.currServ.currencies$;
      this.currencies$.subscribe((val) => console.log('currencies subscription: ', val));
   }

   // USED??
   convertPriceToTL(theCartItem: CartItem): CartItem {
      const originalCurr = theCartItem.scurr;
      if (originalCurr === 'TL') {
         console.log('no need to convert currency');
         return theCartItem;
      }
      console.log('originalCurr: ', originalCurr);
      this.currencies$.subscribe((val) => {
         //  theCartItem.sprice = val.USD.value * theCartItem.sprice
         console.log('cartUtils: ', val);
      });
      console.log('theCartItem.sprice: ', theCartItem.sprice);
      // const convertedPrice = currValue * theCartItem.sprice ;
      // console.log('convertedPrice: ', convertedPrice);
      // theCartItem.sprice = convertedPrice;
      theCartItem.scurr = 'TL';
      console.log(theCartItem);
      return theCartItem;
   }
}
